import { useTranslations } from "../../../../../providers/useTranslations";
export const useCountryTranslations = (allowedCountries) => {
    const { __ } = useTranslations();
    const customLabels = ["ZZ", "phone", "country", "ext"];
    const labels = [...allowedCountries, ...customLabels];
    const countryTranslations = labels.reduce((acc, label) => {
        acc[label] = __("internationalPhone." + label);
        return acc;
    }, {});
    return countryTranslations;
};
//# sourceMappingURL=useCountryTranslations.js.map